import auth from '@/routes/auth';
import guest from '@/routes/guest';

export default [...auth, ...guest];



// WEBPACK FOOTER //
// ./src/routes/index.js